function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 350",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.273,
    y1: 309.6819,
    x2: 352.4985,
    y2: 74.4563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2982F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3295,
    style: {
      stopColor: "#10BCDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6006,
    style: {
      stopColor: "#05D7D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E2CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M250,32c-80.056,0-144.955,64.899-144.955,144.955c0,16.829,2.9,32.974,8.174,48.002   c3.305,18.901,3.753,27.301,1.309,40.229c-1.749,9.254-7.096,15.302-6.2,23.982c0.813,7.876,1.391,12.381,8.438,20.006   c8.318,8.433,16.022,7.915,18.487,8.294c8.559,1.316,14.905-3.541,24.208-4.703c14.633-1.829,25.255-2.831,49.209,3.157   c0.096,0.024,0.179,0.032,0.272,0.053c13.022,3.84,26.792,5.936,41.058,5.936c80.056,0,144.955-64.898,144.955-144.955   S330.056,32,250,32z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FD71C8"
    },
    cx: 270.12,
    cy: 130.106,
    r: 9.81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M186.427,142.008c-5.405,0-10.347,1.096-14.671,3.218c-5.374,2.897-6.15,0.44-6.667-0.22   c-0.52-0.664-0.397-1.475-3.039-1.46h-9.227c0,0-6.281-0.361-5.994,3.817c0,0,0.556,13.489,0.556,21.938v66.688   c0,5.131,3.737,9.756,8.847,10.215c5.773,0.518,10.637-4.035,10.637-9.702v-15.987c0-2.387,2.458-4.078,4.632-3.091   c3.842,1.745,8.207,2.666,12.828,2.666c16.581,0,34.426-12.523,34.426-40.02C218.755,158.015,205.159,142.008,186.427,142.008z    M182.231,203.125c-7.047,0-13.013-4.631-14.887-11.54c-0.001-0.004-0.002-0.008-0.003-0.012c-0.252-1.398-0.473-2.777-0.473-4.229   v-11.609c0-1.317,0.405-2.954,0.723-4.123c1.896-7.359,8.088-12.498,15.059-12.498c11.384,0,16.48,10.806,16.48,21.515   C199.131,194.715,192.813,203.125,182.231,203.125z M330.038,142.008c-4.824,0-9.397,1.045-13.478,3.058   c-1.712,0.844-5.792,0.6-6.816,0.088c-1.042-0.522-1.745-1.607-2.989-1.607h-10.982c-2.128,0-3.807,1.809-3.648,3.931   c0.386,5.144,0.55,10.541,0.55,18.048v43.285c0.086,3.499,0.432,3.658,0.432,3.658c1.537,3.78,5.804,6.386,10.198,6.056   c5.174-0.389,8.993-5.056,8.993-10.244v-34.083c0-1.744,0.23-3.421,0.618-4.483l0.061-0.181c1.524-4.977,6.136-9.998,13.005-9.998   c7.967,0,12.005,5.498,12.005,16.34v32.936c0.288,8.582,6.236,10.044,10.63,9.714c5.174-0.389,8.993-5.056,8.993-10.244v-33.804   C357.612,150.511,342.758,142.008,330.038,142.008z M269.836,143.545c-4.079,0-9.881,2.454-9.881,8.043v57.222   c0,8.019,5.803,9.742,9.881,9.742c5.371,0,9.742-4.371,9.742-9.742v-55.523C279.578,147.915,275.207,143.545,269.836,143.545z    M236.734,111.938c-5.065,0-9.262,3.776-9.763,8.783l-0.018,0.181v88.685l0.018,0.182c0.502,5.007,4.7,8.783,9.763,8.783   c5.427,0,9.843-4.371,9.843-9.742v-87.13C246.577,116.308,242.161,111.938,236.734,111.938z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPlin);
export default __webpack_public_path__ + "static/media/logo-plin.9d2666a5d8cac1735b7a65404253a641.svg";
export { ForwardRef as ReactComponent };